import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import styles from './App.module.css';
import { Navigation } from './components/header/Navigation';
import { TopBar } from './components/header/TopBar'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { MainPageBody } from './pages/MainPageBody';
import { ProductPage } from './pages/ProductPage';
import { PageFooter } from './components/footer/PageFooter';

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <div className={styles.webMain}>
        <header>
          <TopBar />
          <Navigation />
        </header>
        <main>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<MainPageBody />} />
              <Route path="/Product/:id" element={<ProductPage />} />
            </Routes>
          </BrowserRouter>
        </main>
        <footer>
          <PageFooter />
        </footer>
      </div>
      <ReactQueryDevtools />
    </QueryClientProvider>
  );
}

export default App;
